import { Container } from '@mui/material';
import {
    ContentContainer,
    Back,
    PageTitle,
    StyledTextField,
    palette,
} from '@src/core/styles';
import type { FC } from 'react';
import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { FieldGroupWrapper } from '../login-page/login-page.styles';
import { TitleWrapper } from '../offers-form/offers-form.styles';
import { DescriptionText } from '../price-page/price-page.styles';
import {useNavigate, useSearchParams} from 'react-router-dom';
import { ReactComponent as Arrow } from '@src/core/icons/arrow.svg';
import { ReactComponent as Check } from '@src/core/icons/check.svg';
import { joiResolver } from '@hookform/resolvers/joi';
import type {
    SupportErrorResponse,
    SupportErrors,
    SupportRequestParams,
} from '@src/core/types';
import {changePasswordSchema, supportSchema} from '@src/core/schemas';
import { Button } from '@src/components';
import { FormContainer } from '../route-management-page/components/form-component/form-components.styles';
import { Support } from '@src/core/services';
import { useMutation } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';
import { AxiosError } from 'axios';
import {
    ChangePasswordErrorResponse,
    ChangePasswordErrors,
    ChangePasswordRequestParams
} from "@src/core/types/password-change";

export const ChangePasswordForm: FC = () => {
    const navigate = useNavigate();
    const [errorsRequest, setErrorsRequest] = useState<ChangePasswordErrors>();
    const [searchParams, setSearchParams] = useSearchParams();
    const {
        handleSubmit,
        control,
        formState: { errors, isValid },
    } = useForm<ChangePasswordRequestParams>({
        mode: 'onChange',
        resolver: joiResolver(changePasswordSchema),
        defaultValues: {
            password: '',
            password2: '',
            hash: searchParams.get("code"),
            login: searchParams.get("login"),
        },
    });

    const { mutate } = useMutation(Support.password_change, {
        onSuccess: (response) => {
            enqueueSnackbar('Пароль изменен', {
                variant: 'reportComplete',
                className: 'success',
                preventDuplicate: true,
            });
        },
        onError: (error: AxiosError<ChangePasswordErrorResponse>) => {
            setErrorsRequest(error.response?.data.errors);
        },
    });

    // const backHandler = () => {
    //     navigate(-1);
    // };

    const onSubmit = (data: ChangePasswordRequestParams) => {
        mutate(data);
    };

    const changeHandler = () => {
        setErrorsRequest(undefined);
    };

    return (
        <Container>
            <ContentContainer>
                <FormContainer>
            {/*        <Back onClick={backHandler}>*/}
            {/*<Arrow />*/}
            {/*</Back>*/}
            <TitleWrapper>
            <PageTitle>Смена пароля</PageTitle>
    <DescriptionText>
        Изменение пароля
    </DescriptionText>
    </TitleWrapper>
    <form onSubmit={handleSubmit(onSubmit)}>
    <FieldGroupWrapper>
        <Controller
            control={control}
    name="password"
    render={({ field: { value, onBlur, onChange } }) => (
        <StyledTextField
            onBlur={onBlur}
    variant="outlined"
    label="Новый пароль"
    autoComplete="on"
    InputLabelProps={{
        sx: {
            '&.Mui-focused': {
                color: `${palette.colors.green_base}`,
            },
            '&.Mui-error': {
                color: `${palette.colors.error}`,
            },
        },
    }}
    value={value}
    error={!!errors?.password?.message || !!errorsRequest?.password}
    helperText={errors?.password?.message || errorsRequest?.password}
    onChange={(e) => {
        // console.log(e);
        changeHandler();
        onChange(e);
    }}
    />
)}
    />
    <Controller
    control={control}
    name="password2"
    render={({ field: { value, onBlur, onChange } }) => (
        <StyledTextField
            onBlur={onBlur}
    variant="outlined"
    label="Подтверждение пароля"
    placeholder="Подтверждение пароля"
    autoComplete="on"
    InputLabelProps={{
        sx: {
            '&.Mui-focused': {
                color: `${palette.colors.green_base}`,
            },
            '&.Mui-error': { color: `${palette.colors.error}` },
        },
    }}
    value={value}
    error={!!errors?.password2?.message || !!errorsRequest?.password2}
    helperText={errors?.password2?.message || errorsRequest?.password2}
    onChange={(e) => {
        // console.log(e);
        changeHandler();
        onChange(e);
    }}
    />
)}
    />
    </FieldGroupWrapper>
    <Button
    text="Сохранить"
    type="submit"
    variant="contained"
    icon={<Check />}
    borderradius="L"
    disabled={!isValid}
    />
    </form>
    </FormContainer>
    </ContentContainer>
    </Container>
);
};
